import moment from "moment";
import React, { useMemo } from "react";
import {
  KnockOrderItemType,
  ORDER_CANCLE_STATUS,
} from "../../../../recoil/type";
import { getDeliveryComment } from "../../../../utils/StatusComment";
import {
  Option,
  OrderProductType,
  SetPrdType,
  SetProduct,
} from "../../../../controller/OrderController";
import { formatPhoneNumber } from "../../../../utils/util";
import {
  deliverySettingState,
  DeliverySettingType,
} from "../../../../recoil/delivery";
import PrinterController from "../../../../controller/PrinterController";
import DirectMessageController from "../../../../controller/DirectMessageController";
import { getRecoil, setRecoil } from "recoil-nexus";
import { chatState, newChatListState } from "../../../../recoil/chat";
import LogController from "../../../../controller/LogController";

// 펼친 주문 내용 (자세히보기)

type OrderDetailsProps = {
  order: KnockOrderItemType;
  isCopy: boolean;
  deliverySetting: DeliverySettingType;
  setIsCopy: (isCopy: boolean) => void;
  setVisibleReject: (visibleReject: boolean) => void;
};

const OrderDetails = ({
  order,
  isCopy,
  deliverySetting,
  setIsCopy,
  setVisibleReject,
}: OrderDetailsProps) => {
  const OrderDetails = useMemo(() => {
    let bShowDeliveryAppBtn = false;
    if (deliverySetting && deliverySetting.type) {
      if (deliverySetting.type !== "none" && deliverySetting.mode !== 1) {
        bShowDeliveryAppBtn = true;
      }
    }

    const createChatRoom = async () => {
      try {
        const oParams = {
          contact_person: order.store_name,
          contact_person_type: "STORE",
          store_id: order.store_id,
          order_id: order.order_id,
          order_seq: order.child.order_seq,
        };

        const response =
          await DirectMessageController.createChatRoomWithoutAreaId(oParams);

        if (response && response.data) {
          const oRes = response.data;
          if (oRes.data) {
            setRecoil(chatState, (prev) => ({
              ...prev,
              cs_id: oRes.data.cs_id,
              chat_id: oRes.data.cs_id,
              area_name: order.store_name,
              direct_open: true,
            }));
          }
        }
      } catch (err) {
        console.log("err-->", err);
      }
    };

    const getChatRoomData = async () => {
      LogController.click({
        path: "chat Button",
        params: "채팅 버튼 클릭",
        params2: order.order_id,
      });
      try {
        const oParams = {
          store_id: order.store_id,
          order_id: order.order_id,
          order_seq: order.child.order_seq,
          reader_type: "STORE",
        };

        const response = await DirectMessageController.getChatRoomData(oParams);

        if (response && response.data) {
          const oRes = response.data;
          console.log("getChatRoomData", oRes.data);
          if (oRes.data) {
            if (oRes.data.chatRoom) {
              setRecoil(chatState, (prev) => ({
                ...prev,
                cs_id: oRes.data.chatRoom.cs_id,
                chat_id: oRes.data.chatRoom.cs_id,
                area_name: oRes.data.chatRoom.area_name,
                direct_open: true,
              }));
            } else {
              createChatRoom();
            }
            setRecoil(newChatListState, (prev) => [
              ...prev.filter(
                (item) =>
                  !(
                    item.order_id === order.order_id &&
                    item.order_seq === order.child.order_seq &&
                    item.store_id === order.store_id
                  )
              ),
            ]);
          }
        }
      } catch (err) {
        console.log("err-->", err);
      }
    };

    // 주소 복사
    const copyToClipBoardText = () => {
      LogController.click({
        path: "copy Button",
        params: "주소 복사 버튼 클릭",
        params2: order.order_id,
      });
      try {
        //console.log("copy?? 2", order);
        if (navigator && navigator.clipboard) {
          navigator.clipboard.writeText(order.child.delivery_address);
          setIsCopy(true);
        }

        try {
          if (window && window.parent) {
            window.parent.postMessage(
              JSON.stringify({
                action: "copy_address_to_clipboard",
                data: order.child.delivery_address,
              }),
              "*"
            );

            setIsCopy(true);
          }
        } catch (err) {}
      } catch (err) {
        console.log("err", err, order.child?.delivery_address);
      }
    };

    // 콜 접수 버튼
    const copyToDeliveryAppText = () => {
      LogController.click({
        path: "delivery Call Button",
        params: "콜 접수 버튼 클릭",
        params2: order.order_id,
      });
      try {
        if (window && window.parent) {
          let sType = "바로고";
          let iDelaySec = 1000;
          if (getRecoil(deliverySettingState)) {
            console.log("deliverySetting", getRecoil(deliverySettingState));
            sType = getRecoil(deliverySettingState).name;
            iDelaySec = getRecoil(deliverySettingState).app_call_delay;
          }

          let aAddress = order.child.delivery_address.toString().split(" ");
          let sAddr = "";
          if (aAddress) {
            let iStartIdx = 0;
            let iEndIdx = aAddress.length - 1;

            let iIdx = 0;
            for (const item of aAddress) {
              if (item.indexOf("(") !== -1) {
                iEndIdx = iIdx;
                break;
              } else if (item.indexOf(",") !== -1) {
                iEndIdx = iIdx;
                break;
              }
              iIdx++;
            }
            let newArr = aAddress.slice(iStartIdx + 1, iEndIdx);
            sAddr = newArr.join(" ");
          }

          if (aAddress.length === 2) {
            sAddr = order.child.delivery_address.toString();
          }

          // Copy to Delivery App
          let oSendData = {
            type: sType,
            phone_num: order.child.hotel_phone_number,
            addr1: sAddr,
            addr2: order.child.delivery_address_detail,
            inquiry: order.child.inquiry,
            amount: order.child.total_amount_incl,
            delay_sec: iDelaySec,
          };

          // If 테스트 주문
          if (order.child.delivery_address === "테스트 주소") {
            oSendData["phone_num"] = "010-1234-8989";
            oSendData["addr1"] = "송파구 오금로 11길 21-9";
            oSendData["addr2"] = "2층 206";
            oSendData["inquiry"] = "테스트 주문입니다";
            oSendData["amount"] = 10000;
          }

          console.log("oSendData", oSendData);
          window.parent.postMessage(
            JSON.stringify({
              action: "copy_addr_to_delivery_app",
              data: oSendData,
            }),
            "*"
          );
          LogController.delivery({
            path: "Macro call",
            params: sType,
            params2: order.order_id,
          });
        }
      } catch (err) {
        console.log("err", err, order.child?.delivery_address);
      }
    };

    // 영수증 재출력
    const printKitchenReceiptOnly = () => {
      PrinterController.preparePrintData(order, 3, false, true);
      LogController.print({
        path: "rePrint button",
        params: "주문서 재출력",
        params2: order.order_id,
      });
    };

    const printCustomerReceiptOnly = () => {
      console.log("printCustomerReceiptOnly", order);
      PrinterController.preparePrintData(order, 3, true, false);
      LogController.print({
        path: "rePrint button",
        params: "영수증 재출력",
        params2: order.order_id,
      });
    };

    return (
      <div className="orderList detail">
        {/* 주문정보 */}
        <div className="detailWrap">
          <div className="detailItem">
            <div className="listLeft">
              <h3>{order.store_name}</h3>
            </div>
            <div className="listCenter">
              {order.child.detail.map(
                (item: OrderProductType, index: number) => {
                  return (
                    <div className="orderDetailListWrap" key={index}>
                      <div className="detailListWrap">
                        <h3 className="flexItem title">{item.product_name}</h3>
                        <h3 className="flexItem">{item.product_quantity}개</h3>
                        <h3 className="flexItem right">
                          {item.product_total_amount.toLocaleString()}원
                        </h3>
                      </div>
                      {item.set_prd_type_list.map(
                        (set: SetPrdType, setIndex: number) => {
                          return (
                            <div className="optionListWrap" key={setIndex}>
                              <img
                                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_linebreak_black.svg`}
                                alt="img"
                              />
                              <div>
                                {set.set_product.map(
                                  (setPrd: SetProduct, setPrdIndex: number) => {
                                    const getOptionName = () => {
                                      const optionNames = setPrd.options.map(
                                        (option: Option) => option.option_name
                                      );
                                      return optionNames.join(", ");
                                    };
                                    return (
                                      <div key={setPrdIndex} className="row">
                                        <h4>{setPrd.product_name}</h4>
                                        <div className="row option">
                                          <h5>{getOptionName()}</h5>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          );
                        }
                      )}
                      {item.options.map(
                        (option: Option, optionIndex: number) => {
                          return (
                            <div className="optionListWrap" key={optionIndex}>
                              <img
                                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_linebreak_black.svg`}
                                alt="img"
                              />
                              <h4>{option.option_name}</h4>
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
              {order.child.delivery_tip > 0 && (
                <div className="detailListWrap tip">
                  <h3 className="flexItem title">배달팁</h3>
                  <h3 className="flexItem right">
                    {order.child.delivery_tip.toLocaleString()}원
                  </h3>
                </div>
              )}
              {order.child.com_discount_amount +
                order.child.store_discount_amount >
                0 && (
                <div className="detailListWrap tip">
                  <h3 className="flexItem title">할인금액</h3>
                  <h3 className="flexItem right">
                    -
                    {(
                      order.child.com_discount_amount +
                      order.child.store_discount_amount
                    ).toLocaleString()}
                    원
                  </h3>
                </div>
              )}
            </div>
          </div>
          {/* 배달정보 */}
          <div className="detailItem">
            <div className="listLeft">
              <h3>{order.child.hotel_name}</h3>
            </div>
            <div className="listCenter">
              <div className="detailListWrap">
                <div className="flexItem address">
                  <div className="row">
                    <h3 className="address">{order.child.delivery_address}</h3>
                  </div>
                  <div className="row">
                    <button
                      className={`copyButton ${isCopy && "disabled"}`}
                      onClick={copyToClipBoardText}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_copy${
                          isCopy ? "_white" : ""
                        }.svg`}
                        alt="ic"
                      />
                      주소 복사
                    </button>
                  </div>
                  <div className="row center">
                    <h3>{formatPhoneNumber(order.child.hotel_phone_number)}</h3>
                    <button className="chatButton" onClick={getChatRoomData}>
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_siren_line.svg`}
                        alt="siren"
                      />
                      <h5>고객 긴급연락</h5>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 배달기사정보 */}
          {order.delivery_info &&
            order.delivery_info.deliveryManPhoneNumber && (
              <div className="detailItem">
                <div className="listLeft">
                  <h3>기사 연락처</h3>
                </div>
                <div className="listCenter">
                  <div className="detailListWrap">
                    <h3 className="flexItem title">
                      {formatPhoneNumber(
                        order.delivery_info.deliveryManPhoneNumber
                      )}
                    </h3>
                  </div>
                </div>
              </div>
            )}
          {order.child.delivery_tip > 0 && (
            <div className="detailItem sub">
              <div className="listLeft">
                <h3>배달팁</h3>
              </div>
              <div className="listCenter right">
                <h3>{order.child.delivery_tip.toLocaleString()}원</h3>
              </div>
            </div>
          )}
          {/* {order.child.room_tip > 0 && (
          <div className="detailItem sub">
            <div className="listLeft">
              <h3>객실관리팁</h3>
            </div>
            <div className="listCenter right">
              <h3>{order.child.room_tip.toLocaleString()}원</h3>
            </div>
          </div>
        )} */}
          {order.child.com_discount_amount + order.child.store_discount_amount >
            0 && (
            <div className="detailItem">
              <div className="listLeft">
                <h3>할인금액</h3>
              </div>
              <div className="listCenter right">
                <h3>
                  -
                  {(
                    order.child.com_discount_amount +
                    order.child.store_discount_amount
                  ).toLocaleString()}
                  원
                </h3>
              </div>
            </div>
          )}
        </div>
        <div className="listRight">
          {bShowDeliveryAppBtn === true && (
            <button className="call" onClick={copyToDeliveryAppText}>
              {/* <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_copy.svg`}
                alt="ic"
              /> */}
              <h4>배달 콜접수</h4>
            </button>
          )}
          {order.child.order_status !== ORDER_CANCLE_STATUS && (
            <button className="cancel" onClick={() => setVisibleReject(true)}>
              <h4>거절/취소</h4>
            </button>
          )}
          <div className="row">
            <button onClick={() => printKitchenReceiptOnly()}>
              <h4>{"주문서\n재출력"}</h4>
            </button>
            <button onClick={() => printCustomerReceiptOnly()}>
              <h4>{"영수증\n재출력"}</h4>
            </button>
          </div>
        </div>
      </div>
    );
  }, [order, isCopy, deliverySetting]);
  return OrderDetails;
};

export default OrderDetails;
